// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"addFavTooltip_tooltip__ybE3V"};